import { QueryObserverOptions, useQuery } from "react-query";
import { APIError, APIResponse, API_URL, get } from "../api";
import { Product } from "../@types";

function useProductDetails(
  productId: string,
  options?: QueryObserverOptions<APIResponse<Product>, APIError>
) {
  const {
    data: product,
    isError,
    error,
    isLoading,
  } = useQuery<APIResponse<Product>, APIError>(
    "product-details-" + productId,
    () =>
      get(API_URL + "/commerce/products/" + productId, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    options
  );

  return {
    product,
    isError,
    error,
    isLoading,
  };
}

export default useProductDetails;
